// src/components/insights/Citation.jsx

import { useMemo } from "react";
import { useCitationContext } from "./citationContext";

function Citation({ id }) {
  const { getNumber, getReference } = useCitationContext();

  const number = useMemo(() => getNumber(id), [id, getNumber]);
  const reference = getReference(id);

  return (
    <span className="citation-wrapper">
      <a
        href={`#ref-${id}`}
        className="citation"
        onClick={(e) => {
          e.preventDefault();
          document
            .getElementById(`ref-${id}`)
            ?.scrollIntoView({ behavior: "smooth" });
        }}
      >
        [{number}]
      </a>

      {reference && (
        <span className="citation-tooltip">
          {reference}
        </span>
      )}
    </span>
  );
}

export default Citation;